import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { auctionBg, LoginBg } from "../../../Assets";
import routes from "../../../Utils/routes";
import { ReactChildren } from "../../../interfaces/Common";
import { About } from "../../../interfaces/COE";
import LayoutElements from "./components/LayoutElements";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100dvh",
    width: "100%",
    position: "relative",
    backgroundColor: "#101010",
    fontFamily: "Schibsted Grotesk !important",
    backgroundImage: `url(${LoginBg}) !important`,
    backgroundSize: "cover",
    overflow: "hidden",
  },
  desktopLayout: {
    width: "100vw",
    height: "100vh",
    position: "relative",
    overflow: "hidden",
  },
  desktopHeader: {
    height: "80px",
    backgroundColor: "#262728",
    borderBottom: "2px solid #1E1E1E",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopHeaderContainer: {
    width: "90%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  desktopContainer: {
    backgroundImage: `url(${auctionBg}) !important`,
    background:
      "linear-gradient(227deg, #171616 16.8%, #1B0000 53.36%, #242424 81.54%)",
    backgroundSize: "cover",
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundColor: "#262728",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    overflow: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mobileScreen: {
    height: "calc(100% - 32px)",
    width: "calc(100% - 32px)",
    position: "relative",
    padding: "16px",
  },
  desktopScreen: {
    height: "calc(90% - 80px)",
    width: "calc(60% - 80px)",
    maxWidth: "520px",
    maxHeight: "820px",
    position: "relative",
    background: "black",
    overflow: "hidden",
    borderRadius: "20px",
    padding: "40px",
  },
  formContainer: {
    position: "fixed",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100% !important",
    minHeight: "100vh !important",
    width: "100% !important",
    alignItems: "center",
  },
  copywrite: {
    fontSize: "14px !important",
    fontWeight: "500",
    color: "#8A8A8A",
    [theme.breakpoints.down("ultraHD")]: {
      fontSize: "10.5px !important",
    },
  },
  loginVector: {
    height: "330px",
    opacity: "0.1",
    [theme.breakpoints.down("md")]: {
      height: "230px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "130px",
    },
  },
  logo: {
    position: "absolute",
    top: "52%",
    [theme.breakpoints.down("ultraHD")]: { top: "42%" },
    left: "-7%",
    opacity: "10%",
    width: "661px",
    height: "661px",
    zIndex: 1,
  },
}));

const AuctionLayout: React.FC<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isLiveAuction = location.pathname === routes.playerAuction;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
    navigate(routes.login);
  };

  return (
    <>
      <Box className={classes.desktopLayout}>
        <LayoutElements />
        {/* <Box className={classes.desktopHeader}>
            <Box className={classes.desktopHeaderContainer}>
              <img
                src={dskLogo}
                style={{ height: "40px", width: "auto" }}
                alt=""
              />
              <Box
                sx={{
                  color: "white",
                  fontSize: "14px",
                  fontWeight: 600,
                  padding: "6px 12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                  border: "0.5px solid #696969",
                  borderRadius: "60px",
                }}
                onClick={handleLogout}
              >
                Logout <LogoutIcon sx={{ fontSize: "16px" }} />
              </Box>
            </Box>
          </Box> */}
        <Box className={classes.desktopContainer}>
          {/* <Box className={classes.desktopScreen}></Box> */}
          <Box
            sx={{
              p: isLiveAuction ? 0 : { xs: "12px", md: "0.8vw" },
              height: isLiveAuction ? "100%" : { xs: "95%", md: "96%" },
              width: isLiveAuction ? "100%" : { xs: "95%", md: "96%" },
              margin: "auto",
              position: "relative",
              zIndex: "10",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AuctionLayout;
